<div class="dashboard h-100">
    <div class="dashboard-card no-padding d-flex flex-column justify-content-between"
        style="max-width: 800px">
        <div class="row">
            <div class="col-12">
                <div class=" d-flex flex-column padding-container">
                    <h2 class="card-dash-title">Perfis de acessos</h2>
                </div>
            </div>

            <div class="col-12 dashboard-card-body">
                <ng-container *ngIf="loading">
                    <table #table>
                        <tbody>
                            <tr *ngFor="let number of [0,1,2,3,4,5,6]">
                                <td>
                                    <ngx-skeleton-loader [theme]="{
                                        height: '16px',
                                        width: '200px',
                                    marginBottom:'0'                            
                                      }">
                                    </ngx-skeleton-loader>
                                </td>
                                <td class="item-number">
                                    <ngx-skeleton-loader [theme]="{
                                    height: '16px',
                                    width: '40px',
                                    marginBottom:'0',
                                    marginLeft: 'auto'
                                  }">
                                    </ngx-skeleton-loader>
                                </td>
                                <td>
                                    <div
                                        style="display: flex; gap: 16px; justify-content: flex-end;">
                                        <ngx-skeleton-loader [theme]="{
                                            height: '16px',
                                            width: '16px',
                                            marginBottom:'0',
                                            borderRadius: '0'
                                          }">
                                        </ngx-skeleton-loader>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </ng-container>

                <table *ngIf="!loading && groups.length > 0">
                    <thead>
                        <tr>
                            <th>Grupo</th>
                            <th style="text-align:right;">
                                Usuários associados
                            </th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let permission of visible_groups">
                            <td class="doc-item"
                                [style.max-width.px]="tableSize"
                                style="width: 100%;">
                                {{permission.name}}</td>
                            <td style="text-align:right;">
                                {{permission.associated_users}}
                            </td>
                            <td>
                                <div class="table-options">
                                    <app-tooltip text="Editar"
                                        [position]="'top'"
                                        *ngIf="permissionObj.canChange">
                                        <button
                                            (click)="editGroup(permission.id)">
                                            <svg-icon
                                                src="assets/images/icon-edit.svg"></svg-icon>
                                        </button>
                                    </app-tooltip>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="col-12">
                <div class="padding-container d-flex flex-row justify-content-between"
                    *ngIf="loading || groups.length > 0">
                    <app-button [inverted]="true"
                        (onClick)="redirect('/app/permissions/groups')">
                        Ver todos
                    </app-button>

                    <app-button (click)="addGroup()" class="add-button"
                        [disabled]="loading" *ngIf="permissionObj.canAdd">
                        <svg-icon src="assets/images/icon-add.svg"
                            fill="var(--white)" class="mr-2"></svg-icon>
                        Adicionar perfil de acesso
                    </app-button>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12" *ngIf="groups.length === 0 && !loading">
                <div class="empty-card">
                    <div class="img-container">
                        <img src="/assets/images/forgot-password-icon.png"
                            alt="icone">
                    </div>

                    <h3>Defina os perfis de acessos</h3>

                    <p>Ainda não existem perfis cadastrados</p>

                    <app-button (click)="addGroup()" class="add-button"
                        *ngIf="permissionObj.canAdd">
                        <svg-icon src="assets/images/icon-add.svg"
                            class="mr-2"></svg-icon>
                        Adicionar perfil de acesso
                    </app-button>
                </div>
            </div>
        </div>
    </div>
</div>